// client/src/modules/forms/index.ts
import type { ModuleManifest } from '../types';
import { navItems } from './nav';
import { routes } from './routes';

/**
 * Forms module manifest (P8)
 *
 * Field Service Forms - form builder, mobile forms, service reports.
 * Fully migrated to module registry with lazy-loaded routes.
 */
export const formsModule: ModuleManifest = {
  id: 'P8',
  name: 'Forms',
  shortName: 'Forms',
  description: 'Form builder, mobile forms, and service reports',
  icon: '📋',
  status: 'live',
  urlPrefix: '/forms',
  routes,
  navItems,
};

export default formsModule;
